import React from 'react'
import styled from 'styled-components'
import Avatar from 'components/Avatar'
import { hideEmail } from 'utils/user'

const isExternalPerson = a => !a.firstName && !a.lastName && (!!a.email || !!a.name)

const nameOf = a => {
  const full = `${a.firstName || ''} ${a.lastName || ''}`.trim()
  const base = full || a.name || (a.email ? hideEmail(a.email) : 'External')
  return isExternalPerson(a) ? `${base} (external)` : base
}

const AssigneeAvatars = ({ assignees = [], max = 3, size = 22 }) => {
  const people = (assignees || []).filter(Boolean)
  if (people.length === 0) return null

  const shown = people.slice(0, max)
  const extra = people.length - shown.length
  const label = people.map(nameOf).join(', ')

  return (
    <Stack title={label ? `Assigned to ${label}` : undefined} aria-label={label ? `Assigned to ${label}` : undefined}>
      {shown.map((a, i) => {
        const parts = a.name ? a.name.split(' ') : []
        const firstName = a.firstName || parts[0] || a.name
        const lastName = a.lastName || parts.slice(1).join(' ')
        return (
          <Ring key={a.id || i} $external={isExternalPerson(a)}>
            <Avatar src={a.avatar} firstName={firstName} lastName={lastName} email={a.email} size={size} />
          </Ring>
        )
      })}
      {extra > 0 && <More $size={size}>+{extra}</More>}
    </Stack>
  )
}

export default AssigneeAvatars

const Stack = styled.span`
  display: inline-flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`

const Ring = styled.span`
  display: inline-flex;
  border-radius: 50%;
  box-shadow: ${({ $external }) =>
    $external ? '0 0 0 2px #fff, 0 0 0 3.5px #33becc' : '0 0 0 2px #fff'};

  & + & {
    margin-left: -8px;
  }
`

const More = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: #e6e8eb;
  color: #55606b;
  font-size: ${({ $size }) => Math.round($size * 0.38)}px;
  font-weight: 700;
  margin-left: -8px;
  box-shadow: 0 0 0 2px #fff;
`
